/**
 * Keuze bij het verwijderen van een propositie mét actiepunten (Joris 2 okt 2026): verplaatsen naar een andere
 * propositie (= samenvoegen, handig bij dubbelingen) of mee verwijderen. Daarna is alles met undo terug te zetten.
 */
import React, { useEffect, useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, MenuItem, Radio, RadioGroup, TextField, Typography,
} from '@mui/material';

export default function PropositieVerwijderDialog({ open, propositie, aantal = 0, openAantal = 0, anderen = [], onKies, onClose }) {
  const [keuze, setKeuze] = useState('verplaatsen');
  const [naar, setNaar] = useState('');
  useEffect(() => { if (open) { setKeuze(anderen.length ? 'verplaatsen' : 'verwijderen'); setNaar(''); } }, [open, anderen.length]);
  const klaar = keuze === 'verwijderen' || (keuze === 'verplaatsen' && naar);
  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>{propositie?.name || 'Propositie'} verwijderen</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, mb: 1.5 }}>
          Deze propositie heeft {aantal} actiepunt{aantal === 1 ? '' : 'en'}{openAantal ? ` (${openAantal} nog open)` : ''}. Wat moet daarmee gebeuren?
        </Typography>
        <RadioGroup value={keuze} onChange={(e) => setKeuze(e.target.value)}>
          <FormControlLabel value="verplaatsen" disabled={!anderen.length} control={<Radio size="small" />}
            label="Verplaatsen naar een andere propositie (samenvoegen)" />
          {keuze === 'verplaatsen' && (
            <TextField select size="small" label="Naar" value={naar} onChange={(e) => setNaar(e.target.value)} sx={{ ml: 4, mb: 1 }}>
              {anderen.map((p) => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
            </TextField>
          )}
          <FormControlLabel value="verwijderen" control={<Radio size="small" />} label="Actiepunten mee verwijderen" />
        </RadioGroup>
        <Typography sx={{ fontSize: 12.5, color: '#64748b', mt: 1 }}>Je kunt het daarna nog ongedaan maken.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>Annuleren</Button>
        <Button color="error" variant="contained" disableElevation disabled={!klaar}
          onClick={() => onKies({ acties: keuze, naar: keuze === 'verplaatsen' ? naar : undefined })}
          sx={{ textTransform: 'none', fontWeight: 700 }}>Verwijderen</Button>
      </DialogActions>
    </Dialog>
  );
}
